export default function DialogBody(props) {
    return <div style={{ paddingInline: "2em", paddingTop: "0.5em"}} className={props.className}>{props.children}</div>
}
